import React, { useMemo } from "react";

const CategorySection = ({
  formData,
  categories,
  subcategories,
  errors,
  disabled,
  onCategoryChange,
  onSubcategoryChange,
}) => {

  const filteredSubcategories = useMemo(() => {
    return subcategories || [];
  }, [subcategories]);

  const subcategorySelectValue =
    formData.subcategory &&
    formData.category &&
    formData.subcategory === formData.category
      ? "__NO_SUB__"
      : formData.subcategory || "";

  return (
    <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
    
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Category *
        </label>

        <select
          className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none
            ${errors.category ? "border-red-500" : "border-gray-300"}
            ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
          value={formData.category || ""}
          onChange={onCategoryChange}
          name="category"
          disabled={disabled}
        >
          <option value="">Select a category</option>
          {categories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.name}
            </option>
          ))}
        </select>

        {errors.category && (
          <p className="mt-1 text-sm text-red-600">{errors.category}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Subcategory
        </label>

        <select
          className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none
            ${errors.subcategory ? "border-red-500" : "border-gray-300"}
            ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
          value={subcategorySelectValue}
          onChange={onSubcategoryChange}
          name="subcategory"
          disabled={disabled}
        >
          <option value="">Select a subcategory</option>
          <option value="__NO_SUB__">No Subcategory</option>

          {filteredSubcategories.map((sub) => (
            <option key={sub._id} value={sub._id}>
              {sub.subCat}
            </option>
          ))}
        </select>

        {errors.subcategory && (
          <p className="mt-1 text-sm text-red-600">
            {errors.subcategory}
          </p>
        )}
      </div>
    </div>
  );
};

export default CategorySection;
